import actions from "./actions";
import mutations from "./mutations";

const state = {
  UserData: [],
  listStore: [],
  addDataUser: [],
  detailUser: [],
  userId: null,
  searchUser: null,
  resultUser: [],
  dataPerson: [],
  idupdate: null,
  dataemergency: [],
  datepostemergency: [],
  resOtherInfo: [],
  dataOtherPost: [],
  resFamily: [],
  dataFamily: [],
  resultCuti: [],
  search: null,
  list_location: [],
  res_loc: [],
  idLoc: null,
  listProvinsi: [],
  listCity: [],
  listDistrict: [],
  listSubDistrict: [],
  listProvinsi1: [],
  listCity1: [],
  listDistrict1: [],
  listSubDistrict1: [],
  provinsi: null,
  city: null,
  district: null,
  condition: null
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
